import { combineReducers, configureStore } from '@reduxjs/toolkit';

import accountApi from '@/slices/account/account.api';
import activeContextReducer from '@/slices/activeContext/activeContext.slice';
import authApi from '@/slices/auth/auth.api';
import carbonHubApi from '@/slices/carbonHub/carbonHub.api';
import cmsDimensionsApi from '@/slices/cms/dimensions/cmsDimensions.api';
import cmsDisclosureRequirementsApi from '@/slices/cms/disclosureRequirements/cmsDisclosureRequirements.api';
import cmsStandardRequirementsApi from '@/slices/cms/standardRequirements/cmsStandardRequirements.api';
import cmsStandardsApi from '@/slices/cms/standards/cmsStandards.api';
import cmsTopicsApi from '@/slices/cms/topics/cmsTopics.api';
import collectOwnershipsApi from '@/slices/collectOwnerships/collectOwnerships.api';
import consultingCompanyApi from '@/slices/consultingCompany/consultingCompany.api';
import dimensionsApi from '@/slices/dimensions/dimensions.api';
import enterpriseApi from '@/slices/enterprises/enterprise.api';
import featureApi from '@/slices/features/feature.api';
import indicatorsApi from '@/slices/indicators/indicators.api';
import licensingApi from '@/slices/licensing/licensing.api';
import reportExportsApi from '@/slices/report-exports/reportExports.api';
import reportsApi from '@/slices/reports/reports.api';
import resourcesApi from '@/slices/resources/resources.api';
import stakesApi from '@/slices/stakes/stakes.api';
import unitsApi from '@/slices/units/units.api';

export const reducers = combineReducers({
  activeContext: activeContextReducer,
  [authApi.reducerPath]: authApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [consultingCompanyApi.reducerPath]: consultingCompanyApi.reducer,
  [carbonHubApi.reducerPath]: carbonHubApi.reducer,
  [cmsDisclosureRequirementsApi.reducerPath]:
    cmsDisclosureRequirementsApi.reducer,
  [cmsDimensionsApi.reducerPath]: cmsDimensionsApi.reducer,
  [cmsStandardRequirementsApi.reducerPath]: cmsStandardRequirementsApi.reducer,
  [cmsTopicsApi.reducerPath]: cmsTopicsApi.reducer,
  [dimensionsApi.reducerPath]: dimensionsApi.reducer,
  [enterpriseApi.reducerPath]: enterpriseApi.reducer,
  [featureApi.reducerPath]: featureApi.reducer,
  [licensingApi.reducerPath]: licensingApi.reducer,
  [reportExportsApi.reducerPath]: reportExportsApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [resourcesApi.reducerPath]: resourcesApi.reducer,
  [cmsStandardsApi.reducerPath]: cmsStandardsApi.reducer,
  [indicatorsApi.reducerPath]: indicatorsApi.reducer,
  [collectOwnershipsApi.reducerPath]: collectOwnershipsApi.reducer,
  [stakesApi.reducerPath]: stakesApi.reducer,
  [unitsApi.reducerPath]: unitsApi.reducer,
});

const appMiddlewares = [
  authApi.middleware,
  accountApi.middleware,
  consultingCompanyApi.middleware,
  carbonHubApi.middleware,
  cmsDimensionsApi.middleware,
  cmsDisclosureRequirementsApi.middleware,
  cmsStandardRequirementsApi.middleware,
  cmsTopicsApi.middleware,
  dimensionsApi.middleware,
  enterpriseApi.middleware,
  featureApi.middleware,
  licensingApi.middleware,
  reportExportsApi.middleware,
  reportsApi.middleware,
  resourcesApi.middleware,
  cmsStandardsApi.middleware,
  indicatorsApi.middleware,
  collectOwnershipsApi.middleware,
  stakesApi.middleware,
  unitsApi.middleware,
];

export const createAppStore = () =>
  configureStore({
    reducer: reducers,
    middleware: (gDM) => gDM().concat(appMiddlewares),
  });

export const store = createAppStore();

export type AppStore = ReturnType<typeof createAppStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
